package com.mrpowergamerbr.puppydough

import web.dom.document
import web.html.HtmlTagName
import web.url.URL

object DownloadUtils {
    fun download(blobUrl: String) {
        try {
            val link = document.createElement(HtmlTagName.a)
            link.href = blobUrl
            link.download = "saves.zip"
            link.style.display = "none"
            document.body.appendChild(link)
            link.click()
            link.remove()
        } finally {
            URL.revokeObjectURL(blobUrl)
        }
    }
}